export const LOGIN = 'LOGIN';
export const SET_ROLE = 'SET_ROLE';
export const LOGOUT = 'LOGOUT';
